import React from 'react'

import {
  StatusEventAttended,
  StatusProgressCompleted,
  StatusProgressFailed,
  StatusProgressInProgress,
  StatusProgressInProgressRed
} from '../../../components/common/status/Status'
import { ActivityHistoryRowType } from '../activityHistoryTypes'
import { ACTIVITY_HISTORY_STATUSES } from '../activityHistoryConstants'
import { getActivityStatus } from '../activityHistoryUtils'

import { Flex } from 'front-end/src/components'
import ActivityStatusInfo from './ActivityStatusInfo'

type ActivityHistoryRowStatusProps = ActivityHistoryRowType

const ACTIVITY_HISTORY_STATUS_COMPONENTS = {
  [ACTIVITY_HISTORY_STATUSES.COMPLETED]: StatusProgressCompleted,
  [ACTIVITY_HISTORY_STATUSES.IN_PROGRESS]: StatusProgressInProgress,
  [ACTIVITY_HISTORY_STATUSES.FAILED]: StatusProgressFailed,
  [ACTIVITY_HISTORY_STATUSES.ATTENDED]: StatusEventAttended,
  [ACTIVITY_HISTORY_STATUSES.OVERDUE]: StatusProgressInProgressRed
}

const ActivityHistoryRowStatus = (props: ActivityHistoryRowStatusProps) => {
  const status = getActivityStatus(props)
  const StatusComponent = ACTIVITY_HISTORY_STATUS_COMPONENTS[status]

  if (StatusComponent)
    return (
      <Flex alignItems="center" justifyContent="space-between">
        <StatusComponent />
        <ActivityStatusInfo {...props} />
      </Flex>
    )

  return null
}

export default React.memo(ActivityHistoryRowStatus)
